import React from "react";

export default function Footer() {
  return (
    <footer>
      © 2021 SpendCoinDApp make with ❤️ by &nbsp;
      <a rel="noreferrer" target="_blank">
        <strong>
          Wild Team for
          <a
            href="https://www.linkedin.com/company/digital-copilote/"
            rel="noreferrer"
            target="_blank"
          >&nbsp;
            Digital Copilote
          </a>
        </strong>
      </a>
    </footer>
  );
}
